import React from "react";
import { FaWheelchair, FaBullhorn, FaVenusMars, FaUsers } from "react-icons/fa";
import { MdOutlineFamilyRestroom } from "react-icons/md";
import DashboardCard from "../dashbordCard.tsx";
import { dashboardInternData } from "@core/slice/DashboardInternSlice.ts";

import ComplaintCategoryReport from "../complaintCategoryReport.tsx";
import ComplaintsChart from "../complaintChart.tsx";
import { ChartOptions } from "chart.js";
import EntityComplaintNumber from "./entityComplaintNumber.tsx";
import ComplaintNature from "./complaintNature.tsx";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { getInternStat } from "@core/actions/dashboardInternAction.ts";
import { FetchStatusType } from "@core/modeles/model.ts";
import Spinner from "@shared/Spinner.tsx";

const DashboardAdmin: React.FC = () => {
  const dispatch = useAppDispatch();
  const dataDashboard = useAppSelector(dashboardInternData)
  

  React.useEffect(() => {
    dispatch(getInternStat())
  }, [dispatch]);

  const dataDashbord = [
    { icon: <MdOutlineFamilyRestroom />, label: "PE", value: dataDashboard.dataDashboard?.statisticPerCategory?.PE},
    { icon: <FaVenusMars />, label: "VBG", value: dataDashboard.dataDashboard?.statisticPerCategory?.VBG },
    { icon: <FaWheelchair />, label: "PH et PA", value: dataDashboard.dataDashboard?.statisticPerCategory?.PH_AND_PA },
    { icon: <FaBullhorn />, label: "MOCIP", value: dataDashboard.dataDashboard?.statisticPerCategory?.MOCIP },
    { icon: <FaUsers />, label: "PSRC", value: dataDashboard.dataDashboard?.statisticPerCategory?.PSRC },
  ];

  const staticPerWeek = {
    labels: dataDashboard.dataDashboard?.statisticPerWeek?.labels || [],
    datasets: [
      {
        label: "Nombre de plaintes",
        data: dataDashboard.dataDashboard?.statisticPerWeek?.values || [],
        backgroundColor: "rgba(54, 162, 235, 0.8)",
        categoryPercentage: 0.3,
        barPercentage: 0.5,
        borderRadius: 10,
      },
    ],
  };

  const dataToComplaintsChart = {
    labels: dataDashboard.dataDashboard?.statisticPerStatus?.labels || [], 
    values : dataDashboard.dataDashboard?.statisticPerStatus?.values || [],
  };

  const optionsReportBarChart: ChartOptions<"bar"> = {
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        type: "category",
        grid: {
          display: false,
        },
      },
      y: {
        type: "linear",
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return (value as number);
          },
        },
      },
    },
  };
  
  return (
    <div className="w-full column gap-4">
      {dataDashboard.loading === FetchStatusType.COMPLETED && (
        <>
          <div className={`grid gap-4 grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-${Math.min(dataDashbord.length, 5)}`}>
          {dataDashbord.map((item, index) => (
            <DashboardCard
              key={index}
              icon={item.icon}
              label={item.label}
              value={item.value}
            />
          ))}
          </div>
          <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
            <ComplaintCategoryReport
              data={staticPerWeek}
              options={optionsReportBarChart}
              title={"Rapport de plainte hebdomadaire"}
            />
            <ComplaintsChart 
                    title="Statut des plaintes"
                    databyParent={dataToComplaintsChart}
                    count={dataDashboard.dataDashboard?.count}
                  />
          </div>
          <div className="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
            <EntityComplaintNumber plaintes={dataDashboard.dataDashboard?.statisticPerEntities}/>
            <ComplaintNature plaintesPerNature={dataDashboard.dataDashboard?.statisticPerNature}/>
          </div>
        </>
    )}

    {
      dataDashboard.loading === FetchStatusType.LOADING && (
        <div className="flex justify-center items-center h-screen"> 
          <div className="flex justify-center py-4">
            <Spinner />
          </div>
        </div>
      )

    }
    </div>
  );
};

export default DashboardAdmin;
